import { render, staticRenderFns } from "./AiAlert.vue?vue&type=template&id=398bd97b&scoped=true"
import script from "./AiAlert.vue?vue&type=script&lang=js"
export * from "./AiAlert.vue?vue&type=script&lang=js"
import style0 from "./AiAlert.vue?vue&type=style&index=0&id=398bd97b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398bd97b",
  null
  
)

export default component.exports